import React, { useEffect, useState } from 'react';
import Modal from './Modal.js';
import ModalContent from './ModalContent.js';
import ToggleFavs from './ToggleFavs.js';

//needed url to 
const moviePoster1 = 'https://image.tmdb.org/t/p/w200';

export default function RenderMovies({counter, cache}) {

    // const [renderCounter, setRenderCounter] = useState(0);
    const [isHidden, setIsHidden] = useState(true);
    const [movieModal, setMovieModal] = useState(null);
    const [isFirstRender, setIsFirstRender] = useState(true);

    function handleOpenModal() {
        setIsHidden(false);
    }    

    const handleModal = ({ rowIndex, cellIndex }) => {
        handleOpenModal();
        setMovieModal(cache[counter - 1][rowIndex][cellIndex]);
    }

    function render() {
        let array = new Array(2).fill(new Array(4).fill(1));
        if (counter === 0) {
            // setIsFirstRender(false);
            return (
                <div className="container-fluid searched-movies" >
                    <div className=" search-message text-white">
                        <h2>Welcome to Search! <br/> Please enter your search above and prepare to be amazed.</h2>
                    </div>
                    {array.map((row, rowIndex) => (
                        <div className="row d-flex justify-content-around mb-4" key={rowIndex}>
                        {row.map((box, cellIndex) => {
                            const componentStyling = {
                                backgroundColor: "#8D99AE",
                                border: "solid white 4px",
                                height: "300px",
                                width: "200px",
                                textAlign: "center",
                                boxShadow: "rgba(0.40,0,0,0.25) 0px 0px 10px 10px"
                                }
                            return (
                                <div className="empty-display d-flex align-items-center" key={cellIndex} style={componentStyling}>
                                    Search Results will appear here
                                </div>
                            )
                            
                        })}
                        </div>
                    ))}
                </div>
            )
        } else {
            return (
                <div className="container-fluid searched-movies ps-2">
                    <Modal isHidden={isHidden} setIsHidden={setIsHidden} movieModal={movieModal} setMovieModal={setMovieModal} />
                    {cache[counter - 1].map((movieBundle, rowIndex) => (
                        <div className="row d-flex justify-content-around mb-4" key={rowIndex}>
                        {movieBundle.map((movie, cellIndex) => {
                            const moviePoster2 = movie.poster_path;
                            const componentStyling = {
                            backgroundImage: `url(${(moviePoster1 + moviePoster2)})`,
                            backgroundRepeat: "no-repeat",
                            backgroundSize: "cover",
                            height: "300px",
                            width: "200px",
                            textAlign: "center",
                            boxShadow: "rgba(0.40,0,0,0.25) 0px 0px 10px 10px"
                            }
                            return (
                                <div className="ms-2 me-2 mb-2 movie" key={movie.id} style={componentStyling} onClick={() => handleModal({ rowIndex, cellIndex })}>                          
                                </div>
                            )
                        })}
                        </div>
                    ))}
                </div>
            )
            
        }
    }
    
    return (
        <>
            {render()}
        </>
    )
}